import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SettingModuleRouting } from './setting-module-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SettingModuleComponent } from './setting-module.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatIconModule,
    DragDropModule,
    SettingModuleRouting
  ],
  declarations: [SettingModuleComponent]
})
export class SettingModule {
  constructor() { }
}